// usePageViews.js
// Provides an analytics hook that records a page view on every route change.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '../firebase';

/**
 * usePageViews
 * Triggers an analytics page view event whenever the router location changes.
 */
export default function usePageViews() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    track('page_view', {
      page_path: `${pathname}${search}`,
      page_location: window.location.href,
      page_title: document.title || 'LocalVoice',
    });
  }, [pathname, search]);
}
